<template>
  <div class="breadcrumbs p-3">
    <a href="/">Αρχική</a> / <a href="/tickets">Τα εισιτήριά μου</a> / <strong>Το καλάθι μου</strong>
  </div>
  <div class="container-xxl pb-5 cart-container">
    <!-- <div class="back-wrap d-flex mt-3" @click="goBack">
      <img class="back-icon" src="../assets/images/back-icon.png" alt="">
      <p class="back-text">Πίσω</p>
    </div> -->

    <div class="row">
      <h2 class="col-8 cart-title mt-2">Καλάθι εισιτηρίων</h2>
      <div class="col-4 total-tickets-wrap justify-content-end d-flex align-items-center">
        <span class="total-tickets">{{ totalTickets }}</span> Εισιτήρια
      </div>
    </div>

    <div v-if="loading" class="d-flex justify-content-center"><img src="../assets/images/loading.gif" alt="Φόρτωση" width="32"></div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else>
      <div v-if="cart.cart_items && cart.cart_items.length">
        
        <!-- Desktop Table -->
        <div class="d-none d-md-block">
          <table class="table">
            <thead>
              <tr>
                <th>Εκδήλωση</th>
                <th>Ειδική κατηγορία</th>
                <th>Ζώνη</th>
                <th>Τιμή</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in cart.cart_items" :key="item.id">
                <td>
                  <div class="event-image-wrap">
                    <img 
                      :src="item.ticket?.event?.event_img_url || '/path/to/default-image.jpg'" 
                      :alt="item.ticket?.event?.title || 'No image available'" 
                      class="event-image"
                    />
                  </div>
                  <div class="event-info-wrap align-middle">
                    <p class="event-info-venue">{{ item.ticket?.event?.venue?.title || '-' }}</p>
                    <p class="event-info-title">{{ item.ticket?.event?.title || '-' }}</p>
                    <p class="event-info-date">{{ item.formatted_date || '-' }}</p>
                  </div>
                </td>
                <td><p class="ticket-category">{{ item.ticket?.special_category?.title || '-' }}</p></td>
                <td><p class="ticket-zone">{{ item.ticket?.zone?.title || '-' }}</p></td>
                <td><p class="ticket-price">{{ item.price?.toFixed(2) || '0.00' }} €</p></td>
                <td>
                  <img class="close-icon" src="../assets/images/close-icon.png" alt="" @click="deleteCartItem(item.id)">
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Cards -->
        <div class="d-md-none">
          <div v-for="item in cart.cart_items" :key="item.id" class="cart-card">
            <div class="card-header">
              <img 
                :src="item.ticket?.event?.event_img_url || '/path/to/default-image.jpg'" 
                :alt="item.ticket?.event?.title || 'No image available'" 
                class="card-image"
              />
              <div class="card-info">
                <p class="event-info-venue">{{ item.ticket?.event?.venue?.title || '-' }}</p>
                <p class="event-info-title">{{ item.ticket?.event?.title || '-' }}</p>
                <p class="event-info-date">{{ item.formatted_date || '-' }}</p>
                <img class="close-icon" src="../assets/images/close-icon.png" alt="" @click="deleteCartItem(item.id)">
              </div>
            </div>
            <div class="card-body d-flex">
              <div class="card-body-left">
                <p><strong>Είδος:</strong> {{ item.ticket?.special_category?.title || '-' }}</p>
                <p><strong>Ζώνη:</strong> {{ item.ticket?.zone?.title || '-' }}</p>
              </div>
              <div class="card-body-right">
                <p class="ticket-price">{{ item.price?.toFixed(2) || '0.00' }} €</p>
              </div>
            </div>
          </div>
        </div>

        <div class="payment-wrap mt-3">
          <div class="d-flex">
            <div class="total-price-text">Σύνολο</div> 
            <div class="total-price">{{ totalPrice.toFixed(2) }}€</div> 
          </div>         
            <button @click="startPayment" class="payment-btn mt-2">Πληρωμή</button>
        </div>
      </div>
      <div v-else>
        <p>Το καλάθι είναι άδειο.</p>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, computed, inject} from 'vue';
import { getCart, removeTicketFromCart } from '@/services/cart';
import { createPayment } from '@/services/payment';
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
const cartCount = inject('cartCount');




const cart = ref(null);
const loading = ref(true);
const error = ref(null);
const route = useRoute();
const router = useRouter();
const totalTickets = computed(() => cart.value?.cart_items?.length || 0);
const toast = useToast();




async function deleteCartItem(itemId) {
  const result = await removeTicketFromCart({ cart_item_id: itemId });

  if (result.success) {
    cart.value.cart_items = cart.value.cart_items.filter(item => item.id !== itemId);
    cartCount.value--;

    toast('Το εισιτήριο διαγράφηκε.');
  } else {
    toast(result.message);
  }
}

async function startPayment() {
  try {
    const { data } = await createPayment();

    // Create a temporary container
    const container = document.createElement('div');
    container.innerHTML = data; // insert the HTML string
    document.body.appendChild(container);

    // Submit the form
    const form = container.querySelector('form');
    if (form) form.submit();
  } catch (err) {
    console.error(err);
  }
}


function goBack() {
  router.go(-1);
}


onMounted(async () => {
  try {
    loading.value = true;
    error.value = null;
    const data = await getCart();
    cart.value = data.data;
  } catch (err) {
    error.value = 'Failed to load cart';
  } finally {
    loading.value = false;
  }
});

// Compute total price
const totalPrice = computed(() => {
  if (!cart.value?.cart_items) return 0;
  return cart.value.cart_items.reduce((sum, item) => sum + (item.price || 0), 0);
});
</script>


<style scoped>
    .payment-btn{
      background-color: #af0036;
      color:#fff;
      font-size: 20px;
      font-weight: 700;
      border:none;
      width: 100%;
      height: 42px;
      border-radius: 6px;
    }

    .cart-title{
      color: #af0036;
      font-weight: 700;
    }

    .event-info-wrap{
      display:inline-block;
      margin-left:25px;
    }

    .event-info-wrap p{
      line-height: 1.1;
    }

    .cart-container p{
      margin-bottom: 0;
    }

    .event-image-wrap{
      width: 120px;
      height: 75px;
      display:inline-block
    }

    .event-image{
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }

    .event-info-title{
      font-size: 22px;
      font-weight: 700;
    }

    .total-price{
      font-weight: 700;
      width: 100%;
      text-align: right;
      font-size: 22px;
    }

    .total-price-text{
      position: relative;
      top:2px;
      font-size: 18px;
      font-weight: 700;
    }

    .ticket-zone,
    .ticket-category{
      font-size: 16px;
      font-weight: 500;
    }
    
    .ticket-price{
      font-weight: 700;
      font-size: 20px;
    }

    .cart-container .table tr th{
      text-transform: none;
      font-size: 16px;
    }

    .cart-container .table>:not(caption)>*>*{
      padding: 4px 4px;
    }

    .close-icon{
      cursor: pointer;
      width: 30px;
    }
  
    .payment-wrap{
      width: 200px;
    }
     
    .total-tickets-wrap{
      padding-right: 30px;
      font-size: 16px;
    }

    .total-tickets{
      font-weight: 700;
      margin-right:5px;
    }

    .cart-card {
      border: 1px solid #ddd;
      border-radius: 12px;
      padding: 12px;
      position:relative;
      margin-bottom: 16px;
      background: #fff;
      box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    }

    .card-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    .card-image {
      width: 100px;
      height: 70px;
      object-fit: cover;
      border-radius: 8px;
      flex-shrink: 0;
    }

    .card-info {
      flex: 1;
      margin-left: 12px;
    }

    .card-body {
      margin-top: 8px;
    }

    .cart-card .ticket-price {
      font-size: 18px;
      margin-top: 6px;
    }



    @media (max-width: 576px) {
      .event-info-title{
        font-size: 16px;
      }

      .card-body-left{
        width: 50%;
        font-size: 14px;
      }
      
      .card-body-right{
        text-align: right;
        width: 50%;
      }

      .payment-wrap{
        width: unset;
      }

      .event-info-venue{
        font-size: 14px;
      }

      .event-ifno-date{
        font-size: 13px;
      }

      .total-tickets-wrap{
        padding-right: 15px;
        font-size: 16px;
      }

      .close-icon{
        position:absolute;
        top:5px;
        right:5px;
      }

      .back-text{
        top:6px;
      }

      .cart-title{
        font-size: 22px;
      }

    }

</style>